import { HashRouter } from "react-router-dom";
import Main from "./Main";

export default function App() {
  	return	<HashRouter>
		  		<div className="h-100 d-flex flex-column overflow-auto">
		  			<Main></Main>
				</div>
    		</HashRouter>
}